module.exports = Object.entries;